export const GET_CITY = 'GET_CITY';
export const GET_WEATHER = 'GET_WEATHER';
export const GET_FORECAST = 'GET_FORECAST';